/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cognito_identity_pool_id": "eu-west-2:529bd30e-9f98-4a4c-96f2-7db2f4c9a54f",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_imVSIdT6T",
    "aws_user_pools_web_client_id": "6bj3bvdmbc0o11nojt64ctj5j2",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "ADDRESS",
        "EMAIL",
        "FAMILY_NAME",
        "GIVEN_NAME",
        "PHONE_NUMBER",
        "WEBSITE"
    ],
    "aws_cognito_mfa_configuration": "ON",
    "aws_cognito_mfa_types": [
        "SMS",
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "naspro",
            "endpoint": "https://lcosmmzif7.execute-api.eu-west-2.amazonaws.com",
            "region": "eu-west-2"
        }
    ],
    "aws_user_files_s3_bucket": "nsprobucket165028-stage",
    "aws_user_files_s3_bucket_region": "eu-west-2"
};


export default awsmobile;
